<template>
    <el-dialog title="添加心仪高校" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-identify">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler">
        <div class="search-img header-search">
            <el-input placeholder="搜索学校名称" v-model="search.scl_name" clearable @keyup.enter.native="searchData">
                <template slot="append">
                    <img src="@/assets/images/sousuo.png" alt="搜索" @click="searchData">
                </template>
            </el-input>
        </div>
        <el-scrollbar wrap-class="vertical_scrollbar">
            <el-table :data="school_options" @row-click="selectSchool">
                <el-table-column prop="scl_name"></el-table-column>
                <el-table-column width="100" align="right">
                    <template slot-scope="scope">
                        <div class="item-view">
                            <img v-if="!scope.row.checked" src="@/assets/images/select_icon1.png">
                            <img v-else src="@/assets/images/select_icon2.png">
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-scrollbar>
        <div class="flex">
            <el-popover
                placement="top"
                popper-class="popper-view"
                trigger="click"
                :visible-arrow="false"
                @hide="show_data=false"
            >
                <el-table :data="select_school">
                    <el-table-column prop="scl_name" min-width="200"></el-table-column>
                    <el-table-column width="100" align="right">
                        <template slot-scope="scope">
                            <div class="remove-btn" @click="removeSchool(scope.row, scope.$index)">移除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add-count" slot="reference" @click="show_data=!show_data">已添加：<span>{{ select_school.length }}</span>/5<i v-if="!show_data" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i></div>
            </el-popover>
            <div>
                <el-button @click="closeHandler">取消</el-button>
                <el-button class="save-btn" @click="addSchool">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getSearchSchoolList } from '@/api/zhiyuan'

export default {
    name: 'IntentionSchool',
    props: ['schoolList'],
    data() {
        return {
            school_options: [],
            select_school: [],
            show_data: false,
            search: {
                scl_name: ''
            }
        }
    },
    mounted() {
        this.select_school = [...this.schoolList]
        this.getSearchSchoolListHandler()
    },
    methods: {
        closeHandler() {
            this.$store.commit('user/SHOWINTENTIONSCHOOL', false)
        },
        searchData() {
            this.school_options = []
            this.getSearchSchoolListHandler()
        },
        // 获取学校列表
        getSearchSchoolListHandler() {
            getSearchSchoolList(this.search.scl_name).then(res => {
                res.data.map(item => { item.checked = false })
                this.school_options = res.data
                this.select_school.map(item => {
                    const index = this.school_options.findIndex( val => {return val.scl_id === item.scl_id })
                    if(index > -1) {
                        this.school_options[index].checked = true
                    }
                })

            })
        },
        // 学校切换
        selectSchool(row, column) {
            const index_tmp = this.select_school.findIndex(val => { return val.scl_id === row.scl_id})
            if(index_tmp === -1) {
                if(this.select_school.length > 4) {
                    return
                }
                row.checked = true
                this.select_school.push(row)
            } else {
                row.checked = false
                this.select_school.splice(index_tmp, 1)
            }
        },
        // 学校提交
        addSchool() {
            this.$emit('update', this.select_school)
            this.closeHandler()
        },
        // 移除学校
        removeSchool(data, index) {
            const index_tmp = this.school_options.findIndex(val => { return val.scl_id === data.scl_id })
            if(index_tmp > -1) {
                this.school_options[index_tmp].checked = false
            }
            this.select_school.splice(index, 1)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    ::v-deep .el-dialog {
        height: 600px;
        width: 720px;
        .vertical_scrollbar {
            overflow-x: hidden;
            height: 355px;
            min-height: 300px;
            padding-bottom: 20px;
            .el-table__header-wrapper {
                display: none;
            }
        }
        .el-button {
            width: 100px!important;
            height: 44px!important;
            background: #ffffff!important;
            border: 1px solid #c4c7cc!important;
            border-radius: 8px;
            color: #5e6166!important;
            font-size: 16px;
        }
        .save-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border: none!important;
            color: #ffffff!important;
        }
    }
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    .item-view {
        position: relative;
        img {
            position: relative;
            right: -8px;
            top: 5px;
            width: 20px;
            height: 20px;
        }
    }
    .provice-view {
        color: #999390;
        margin-top: 12px;
    }
    .flex {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .add-count {
            font-size: 14px;
            span {
                color: #ff6524;
            }
        }
    }
}
.remove-btn {
    color: #ff6524;
    cursor: pointer;
}
.el-icon-arrow-down {
    color: #c4c7cc;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
    top: 2px;
}
.el-icon-arrow-up {
    color: #ff6524;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
}
::v-deep .header-search {
    position: relative;
    z-index: 1000;
    .el-input__inner {
        padding: 0 16px;
    }
    .el-input-group__append {
        img {
            position: absolute;
            top: 10px;
            right: 16px;
        }
    }
}
</style>